import {
  deriveEstadoRegistro,
  ESTADO_REGISTRO_LABEL,
  ESTADO_REGISTRO_BADGE_VARIANT,
  BadgeVariant,
} from '../utils/estadoRegistro';
import { Miembro } from '../lib/supabase';

const VARIANT_CLASS: Record<BadgeVariant, string> = {
  default: 'bg-slate-100 text-slate-600',
  info: 'bg-blue-50 text-blue-700',
  danger: 'bg-red-50 text-red-700',
  prerregistrado: 'bg-orange-100 text-orange-700',
  success: 'bg-emerald-50 text-emerald-700',
};

interface EstadoRegistroBadgeProps {
  readonly miembro: Pick<
    Miembro,
    'estado_ficha' | 'invitation_token' | 'invitation_expires_at' | 'invitation_used_at'
  >;
}

export const EstadoRegistroBadge: React.FC<EstadoRegistroBadgeProps> = ({ miembro }) => {
  const estado = deriveEstadoRegistro(miembro);
  const variant = ESTADO_REGISTRO_BADGE_VARIANT[estado];
  return (
    <span
      className={`inline-flex items-center text-xs px-2 py-0.5 rounded-full font-medium ${VARIANT_CLASS[variant]}`}
    >
      {ESTADO_REGISTRO_LABEL[estado]}
    </span>
  );
};
